module.exports = __webpack_public_path__ + "img/running-phase.50558796.png";